export var FakeChapters = {
    FAVORITES: "--customFavOnly--"
};
